import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'We had a major pipe burst at 2 AM. Done Right Plumbing was there within an hour. The plumber was professional, stopped the leak quickly, and had everything repaired by morning. Absolute lifesavers.',
  name: 'Michael T.',
  location: 'Residential Customer',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=150&auto=format&fit=crop'
}, {
  quote: "As a restaurant owner, plumbing issues cost me money. I've used Done Right for 5 years now. They are always prompt, their pricing is fair, and the work is impeccable. Highly recommend their commercial team.",
  name: 'Sarah Jenkins',
  location: 'Local Business Owner',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=150&auto=format&fit=crop'
}, {
  quote: 'They installed a new tankless water heater for us. The crew was respectful of our home, laid down drop cloths, and explained exactly how the new system worked before leaving. True professionals.',
  name: 'David & Lisa R.',
  location: 'Homeowner',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=150&auto=format&fit=crop'
}];
export function Testimonials() {
  return <section className="py-24 bg-white" data-id="element-317">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-318">
        <div className="text-center mb-16" data-id="element-319">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-brand-navy uppercase mb-4" data-id="element-320">
            What Our Customers Say
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto" data-id="element-321">
            Don't just take our word for it. Read what your neighbors have to
            say about our 33 years of dedicated service.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-322">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-gray p-8 rounded-md border border-gray-200 relative flex flex-col h-full" data-id="element-323">
              <div className="flex gap-1 mb-6" data-id="element-324">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-red text-brand-red" data-id="element-325" />)}
              </div>
              <p className="text-gray-700 italic mb-8 leading-relaxed flex-grow" data-id="element-326">
                "{testimonial.quote}"
              </p>
              <div className="mt-auto flex items-center gap-4 pt-4 border-t border-gray-200" data-id="element-327">
                <img src={testimonial.avatar} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm" data-id="element-328" />
                <div data-id="element-329">
                  <p className="font-bold text-brand-navy uppercase tracking-wide leading-tight" data-id="element-330">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-331">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}